<template>
  <div class="import-modern">
    <form @submit="handleImport($event)" class="import-form">
      <!-- Header Section -->
      <div class="import-header">
        <div class="header-content">
          <h3 class="import-title">
            <i class="fas fa-file-import title-icon"></i>
            Importação de Dados
          </h3>
          <p class="import-subtitle">
            Importe seus dados usando arquivo Excel (.xls/.xlsx) ou CSV
          </p>
        </div>
      </div>

      <!-- Instructions Card -->
      <div class="instructions-card">
        <div class="card-header">
          <h4 class="card-title">
            <i class="fas fa-info-circle mr-2"></i>
            Instruções de Importação
          </h4>
        </div>
        <div class="card-content">
          <div class="instruction-steps">
            <div class="step-item">
              <div class="step-number">1</div>
              <div class="step-content">
                <h5 class="step-title">Baixe o arquivo modelo</h5>
                <p class="step-description">
                  Use o arquivo modelo para garantir que suas colunas estejam no
                  formato correto
                </p>
                <v-btn @click="downloadXls" class="download-btn" small>
                  <i class="fas fa-download mr-2"></i>
                  Baixar Modelo
                </v-btn>
              </div>
            </div>

            <div class="step-item">
              <div class="step-number">2</div>
              <div class="step-content">
                <h5 class="step-title">Preencha os dados</h5>
                <p class="step-description">
                  Complete o arquivo com seus dados seguindo exatamente a ordem
                  das colunas do modelo
                </p>
                <div class="warning-box">
                  <i class="fas fa-exclamation-triangle warning-icon"></i>
                  <span class="warning-text">
                    A ordem dos nomes das colunas deve ser exatamente idêntica
                    ao arquivo modelo!
                  </span>
                </div>
              </div>
            </div>

            <div class="step-item">
              <div class="step-number">3</div>
              <div class="step-content">
                <h5 class="step-title">Selecione o arquivo</h5>
                <p class="step-description">
                  Escolha o arquivo preenchido para fazer a importação
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- File Upload Card -->
      <div class="upload-card">
        <div class="card-header">
          <h4 class="card-title">
            <i class="fas fa-cloud-upload-alt mr-2"></i>
            Upload do Arquivo
          </h4>
        </div>
        <div class="card-content">
          <div class="upload-section">
            <LabelRequiredField label="Arquivo para Importação" />
            <div class="file-upload-container">
              <b-form-file
                name="file"
                :disabled="loading"
                placeholder="Selecione ou arraste o arquivo aqui"
                drop-placeholder="Solte o arquivo aqui..."
                browse-text="Procurar"
                accept=".xls, .xlsx, .csv, .ods"
                id="file"
                class="modern-file-input"
              />
              <div class="file-info">
                <div class="format-info">
                  <i class="fas fa-file-alt mr-1"></i>
                  <span
                    >Formatos aceitos: Excel (.xls, .xlsx), CSV, LibreOffice
                    Calc (.ods)</span
                  >
                </div>
                <div class="size-info">
                  <i class="fas fa-weight-hanging mr-1"></i>
                  <span>Tamanho máximo: 10MB</span>
                </div>
              </div>
            </div>
          </div>

          <ErrorsMessages :errors="errors" />
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-section">
        <v-btn
          :disabled="loading"
          type="submit"
          class="import-btn"
          :loading="loading"
        >
          <i class="fas fa-upload mr-2"></i>
          {{ loading ? "Importando..." : "Importar Dados" }}
        </v-btn>
      </div>
    </form>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";
import LabelRequiredField from "../../Components/LabelRequiredField";
import toast from "../../../lib/ToastNotification";
import api from "../../../services/api";

export default {
  name: "Import",
  components: {
    ErrorsMessages,
    LabelRequiredField,
  },
  data() {
    return {
      json_data: [],
      loading: false,
      errors: [],
    };
  },

  created() {
    let json_data = [
      {
        "Nome/Razão Social": "",
        "Nome Fantasia": "",
        "CPF/CNPJ": "",
        "I.E.": "",
        "I.M.": "",
        Telefone: "",
        Endereço: "",
        Número: "",
        Complemento: "",
        CEP: "",
        Cidade: "",
        Estado: "",
        Email: "",
        Observação: "",
        Ativo: "SIM",
      },
    ];

    this.json_data = json_data;
  },

  methods: {
    downloadXls() {
      var items = this.json_data;
      let replacer = (key, value) => (value === null ? "" : value);
      let header = Object.keys(items[0]);
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(";")
      );
      csv.unshift(header.join(";"));
      csv = csv.join("\r\n");

      let link = document.createElement("a");

      link.setAttribute(
        "href",
        `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(csv)}`
      );
      link.setAttribute("download", "Exemplo.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async handleImport(event) {
      try {
        event.preventDefault();

        this.loading = true;
        this.errors = [];

        const formData = new FormData();
        let files = document.getElementById("file").files;

        if (!files || files.length == 0) {
          this.loading = false;
          this.errors = ["Por favor, selecione um arquivo para importação"];
          return;
        }

        const allowedMimes = [
          "application/vnd.ms-excel",
          "application/msexcel",
          "application/x-msexcel",
          "application/x-ms-excel",
          "application/x-excel",
          "application/x-dos_ms_excel",
          "application/xls",
          "application/x-xls",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];

        for (const file of files) {
          if (!allowedMimes.includes(file.type)) {
            this.loading = false;
            this.errors = [
              "Formato de arquivo inválido. Use Excel (.xls/.xlsx) ou CSV",
            ];
            return;
          }

          var limitSize = 10 * 1024 * 1024;

          if (file.size > limitSize) {
            this.loading = false;
            this.errors = [
              "Arquivo muito grande. Tamanho máximo suportado: 10MB",
            ];
            return;
          }

          formData.append("file", file);
        }

        let response = await api.post(
          "/rest-home/financial/client-import",
          formData
        );

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("success");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.errors = ["Erro interno. Tente novamente mais tarde."];
      }
    },
  },
};
</script>

<style scoped>
.import-modern {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
  padding: 24px;
}

.import-form {
  max-width: 900px;
  margin: 0 auto;
}

/* Header Section */
.import-header {
  background: white;
  border-radius: 16px 16px 0 0;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid #e5e7eb;
}

.header-content {
  text-align: center;
}

.import-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
  font-size: 24px;
}

.import-subtitle {
  color: #64748b;
  margin: 0;
  font-size: 16px;
}

/* Instructions Card */
.instructions-card {
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border-left: 4px solid #0f65b0;
  margin-bottom: 24px;
}

.card-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.card-content {
  padding: 24px;
}

.instruction-steps {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.step-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.step-number {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

.step-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
}

.step-description {
  color: #64748b;
  margin: 0 0 12px 0;
  font-size: 14px;
  line-height: 1.5;
}

.download-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.download-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4) !important;
}

.warning-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  border: 1px solid #f59e0b;
  border-radius: 8px;
  padding: 12px;
  margin-top: 8px;
}

.warning-icon {
  color: #d97706;
  font-size: 16px;
}

.warning-text {
  color: #92400e;
  font-size: 13px;
  font-weight: 500;
}

/* Upload Card */
.upload-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
  overflow: hidden;
}

.upload-section {
  margin-bottom: 20px;
}

.file-upload-container {
  position: relative;
}

.modern-file-input {
  margin-bottom: 16px;
}

.file-info {
  display: flex;
  gap: 24px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.format-info,
.size-info {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #6b7280;
}

.format-info i,
.size-info i {
  color: #0f65b0;
  margin-right: 4px;
}

/* Action Section */
.action-section {
  text-align: center;
  padding: 24px;
  background: white;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.import-btn {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 16px 32px !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
  min-width: 200px !important;
}

.import-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

.import-btn:disabled {
  opacity: 0.7 !important;
  transform: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .import-modern {
    padding: 16px;
  }

  .import-header {
    padding: 24px 20px;
  }

  .import-title {
    font-size: 24px;
    flex-direction: column;
    gap: 8px;
  }

  .card-content {
    padding: 20px;
  }

  .instruction-steps {
    gap: 20px;
  }

  .step-item {
    flex-direction: column;
    gap: 12px;
  }

  .file-info {
    flex-direction: column;
    gap: 8px;
  }

  .import-btn {
    padding: 14px 24px !important;
    font-size: 14px !important;
  }
}

/* Custom File Input Styling */
.modern-file-input >>> .custom-file-label {
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 24px;
  background: #f8fafc;
  color: #64748b;
  text-align: center;
  transition: all 0.3s ease;
}

.modern-file-input >>> .custom-file-label:hover {
  border-color: #0f65b0;
  background: #f1f5f9;
}

.modern-file-input >>> .custom-file-label::after {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  border-radius: 8px;
  font-weight: 600;
}
</style>